module.exports = __webpack_public_path__ + "static/media/expand-alt.21359435.svg";